import { HdTaskState } from '@zaoblako/web/modules/help-desk/components/task/card/models/hd-task-state';

export const hdTaskInitialState: HdTaskState = {
  loading: false,
  showActionButtons: true,
  task: null,
  countComments: 0,
  panelsInfo: {
    actionsShow: true,
    dealShow: true,
    projectShow: true,
    additionalDetailsShow: true
  },
  filesInfo: {
    files: [],
    loading: false
  },
  editedField: null,
  userGroups: [],
  taskTypes: [],
  requiredFields: null,
  defaultClient: null,
  helpdeskNotificationSettings: null
};
